module.exports = __webpack_public_path__ + "static/media/gibson-bold.0ddb5ff5.ttf";